import React from 'react';
import { gapi } from 'gapi-script';
import { useState,useEffect, useRef } from 'react';
import AWS from 'aws-sdk';
AWS.config.update({
  accessKeyId: "AKIAWZB5KF6EBGT3RIHI",
  secretAccessKey: "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",
  region: "us-west-2"
});
// Function to create a Google Meet event draft



const createDraftMeetEvent = async (eventName, eventDescription, start, end, showmeetlink, setMeetLink, setGenerateloading) => {
  const event = {
    summary: eventName,
    description: eventDescription,
    start: {
      dateTime: start,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    end: {
      dateTime: end,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    conferenceData: {
      createRequest: {
        requestId: 'sample123',
        conferenceSolutionKey: {
          type: 'hangoutsMeet',
        },
      },
    },
  };

  const request =  gapi.client.calendar.events.insert({
    calendarId: 'primary',
    resource: event,
    conferenceDataVersion: 1,
  });

  request.execute(event => {
    console.log(event.hangoutLink, "Meet Link");
    setMeetLink(event.hangoutLink);
    // showmeetlink(event.hangoutLink);
    
    // Save eventId for later use
    localStorage.setItem('eventId', event.id);
    setGenerateloading(false)
  });
};

// Function to finalize the event and send the invitation
const finalizeMeetEvent = async (email, eventName, eventDescription, start, end, showmeetlink, setMeetLink, setGenerateloading1) => {
  const eventId = localStorage.getItem('eventId');
  const event = {
    summary: eventName,
    description: eventDescription,
    start: {
      dateTime: start,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    end: {
      dateTime: end,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    attendees: [
      { email: email },
    ],
    reminders: {
      useDefault: false,
      overrides: [
        { method: 'email', minutes: 24 * 60 },
        { method: 'popup', minutes: 10 },
      ],
    },
  };

  const request = gapi.client.calendar.events.patch({
    calendarId: 'primary',
    eventId: eventId,
    resource: event,
    conferenceDataVersion: 1,
    sendUpdates: 'all',
  });

  request.execute(event => {
    console.log(event.hangoutLink, "Finalized Meet Link");
      showmeetlink(event.hangoutLink);
    // setMeetLink(event.hangoutLink);
    setGenerateloading1(false)
  });
  
};
// React component to create a Meet event
function CreateMeet({ eventName, eventDescription, start, end, showmeetlink,data}) {
  console.log(eventName);
  console.log(eventDescription);
  console.log(start);
  console.log(end);
  console.log(showmeetlink);
  console.log(data);
  
  function formatDateTime(dateTime) {
    const date = new Date(dateTime);
    return date.toISOString();
  }

  const [email, setEmail] = React.useState('avinash20802bala@gmail.com');
  const [meetLink, setMeetLink] = React.useState('');
  const [userdata,setUserdata]=useState('')
  const [generateloading, setGenerateloading] = React.useState(false);
  const [generateloading1, setGenerateloading1] = React.useState(false);
  const [startdate,setStartdate]=useState([]);
  const [enddate,setEnddate]=useState([]);
  const [useremail,setUseremail]=useState([]);

  useEffect(() => {
    // Ensure the values are valid before parsing
    if (start && end) {
      try {
        const parsestartdata = JSON.parse(start);
        const parseenddata = JSON.parse(end);
        
        setStartdate(parsestartdata[0]);
        setEnddate(parseenddata[0]);

        console.log('Parsed Start Array:', parsestartdata);
        console.log('Parsed End Array:', parseenddata);

      } catch (e) {
        console.error('Error parsing JSON:', e);
      }
    }
  }, [start, end]);


  const meetLinkInputRef = useRef(null);

function formatDate(dateString) {
  const date = new Date(dateString);

  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day} ${month} ${year} ${hours}:${minutes}`;
}
  const sendEmail = () => {
    setGenerateloading1(true);
    let parsedData = [];
    try {
        parsedData = JSON.parse(start);
        console.log(parsedData, "Parsed Data");
    } catch (error) {
        console.error("Error parsing start data:", error);
    }
    const baseemail=encodeURIComponent(data.email);
    const baseUrl = "https://schedulemeet.vercel.app/schedulemeeting";
    const encodedename= encodeURIComponent(eventName);
    const encodedeedisp= encodeURIComponent(eventDescription);
    const encodedFirst = start?encodeURIComponent(start):"";
    // const encodedSecond = startdate?encodeURIComponent(startdate):"";
    // const encodedThird = startdates?encodeURIComponent(startdates):"";
    const virtual=encodeURIComponent("virtual");
    // const actionUrl = `${baseUrl}?first=${encodedFirst}&second=${encodedSecond}&third=${encodedThird}&eventname=${encodedename}&eventdesp=${encodedeedisp}&email=${baseemail}&virtual=${virtual }`;
    let actionUrl = `${baseUrl}?eventname=${encodedename}&email=${baseemail}&virtual=${virtual }`;
    if (encodedFirst) {
      actionUrl += `&first=${encodedFirst}`;
    }
    if (encodedeedisp) {
      actionUrl += `&eventdesp=${encodedeedisp}`;
    }
    let sendto ="avinash20802bala@gmail.com"
    let userto = data?data.email:""
    var subjectdata="Virtual Meeting Request Notification"
    var usersubjectdata="Virtual Meeting Request Notification"
    const meetingDatesHtml =parsedData? parsedData
    .map((data) => `<p style="margin-bottom:4px; margin-top:0px;font-size:16px;"><b>Meeting Date:</b> ${formatDate(data.value)}</p>`)
    .join(""):'';

     var messagedata =`
     <html>
     <head>
       <meta charset="UTF-8">
       <meta name="viewport" content="width=device-width, initial-scale=1.0">
     </head>
     <body style="font-family: Arial, sans-serif;margin: 0;padding: 0;background-color: #f4f4f4;">
       <div class="container" style="width: 100%;max-width: 600px;margin: 0 auto;background-color: #ffffff; border-radius: 8px;overflow: hidden;box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);">
         <div class="header" style="background-color: #007bff;color: #ffffff;padding: 20px;text-align: center;">
           <h1>Virtual Meeting Request Notification</h1>
         </div>
         <div class="body">
           <p style="font-size:16px;">Dear Mamdoh,</p>
           <p style="font-size:16px;">I hope this email finds you well. </p>
           <p style="font-size:16px;">I wanted to inform you that we have received a request for a virtual meeting. Below are the details of the request:
          </p>
            ${meetingDatesHtml}
           <p style="font-size:16px;">Please review the request and let me confirm your availability.</p>
           <a href=${actionUrl} class="button" style="color:#ffffff;text-decoration:none; display:inline-block;padding:10px 20px;margin:10px 0;background-color:#007bff;color:#ffffff;font-size:16px;"
           text-align: center;border-radius: 5px;text-decoration: none;">Click Here</a>
           <p style="font-size: 16px;">Thank you</br>
           This is an automated email.</p>
         </div>
       </div>
     </body>
     </html>
     `


     var usermessagedata =`
     <html>
     <head>
       <meta charset="UTF-8">
       <meta name="viewport" content="width=device-width, initial-scale=1.0">
     </head>
     <body style="font-family: Arial, sans-serif;margin: 0;padding: 0;background-color: #f4f4f4;>
       <div class="container" style="width: 100%;max-width: 600px;margin: 0 auto;background-color: #ffffff; border-radius: 8px;overflow: hidden;box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);">
         <div class="header" style="background-color: #007bff;color: #ffffff;padding: 20px;text-align: center;">
           <h1>Confirmation of Virtual Meeting Request Submission</h1>
         </div>
         <div class="body">
           <p style="font-size: 16px;">Dear ${data?data.name:""},</p>
           <p style="font-size: 16px;">Thank you for your request to schedule a virtual meeting.</p>
           <p style="font-size: 16px;">We have successfully received your submission and are in the process of reviewing the details.:
          </p>
          <p style="font-size: 16px;">Here is a summary of your request:</p>
            ${meetingDatesHtml}
            <p style="margin-bottom:2px;font-size: 16px;"><b>Purpose of Meeting:</b>${eventDescription?eventDescription:""} </p>
           <p style="font-size: 16px;">We will get back to you shortly with a confirmation of the meeting or any additional information we might need.</p>
           <p style="font-size: 16px;">Thank you for your patience. We look forward to connecting with you soon.<br/>
            Best regards,Mamdoh</p>
         </div>
       </div>
     </body>
     </html>
     `
    // Create an instance of the SES service
    const ses = new AWS.SES({ apiVersion: '2023-08-09' });
    const params = {
      Destination: {
        ToAddresses: [sendto], // Replace with the recipient's email address
      },
      Message: {
        Body: {
          Html: {
            Data: messagedata // Email content
          }
        },
        Subject: {
          Data: subjectdata // Email subject
        }
      },
      Source: 'admin@brokeragentbase.com' // Replace with your verified sender email address
    };

    const userparams = {
      Destination: {
        ToAddresses: [userto], // Replace with the recipient's email address
      },
      Message: {
        Body: {
          Html: {
            Data: usermessagedata // Email content
          }
        },
        Subject: {
          Data: usersubjectdata // Email subject
        }
      },
      Source: 'admin@brokeragentbase.com' // Replace with your verified sender email address
    };

    // Send the email
    ses.sendEmail(params,(err, data) => {
      if (err) {
        console.error('Error sending email:', err);
      } else {
        console.log('Email sent successfully:', data);
        setGenerateloading1(false);
        showmeetlink("link");
      }
    });
    ses.sendEmail(userparams,(err, data) => {
      if (err) {
        console.error('Error sending email:', err);
      } else {
        console.log('Email sent successfully:', data);
        setGenerateloading1(false);
        showmeetlink("link");
      }
    });
  };
  const handleGenerateLink = (e) => {
    e.preventDefault();
    setUserdata(data)
    console.log(startdate.value,"Userdata");
    setGenerateloading(true);
    // const formattedStart = start?start[0].value:"";
    const formattedstartdate = startdate?formatDateTime(startdate.value):"";
    // const formattedstartdates = startdates?formatDateTime(startdates):"";
     const formattedEnd = enddate?formatDateTime(enddate.value):"";
    // const formattedEnd = end?end:"";
    createDraftMeetEvent(eventName, eventDescription, formattedstartdate, formattedEnd, showmeetlink, setMeetLink, setGenerateloading);
  };


  function copyToClipboard() {
    if (meetLinkInputRef.current) {
      meetLinkInputRef.current.select();
      document.execCommand('copy');
      alert('Meet link copied to clipboard');
    }
  }
  return (
    <div>
      {
        meetLink ?
        <></>
        :
        <>
        {console.log(useremail)}
          <form onSubmit={handleGenerateLink}>
            <button title="Generate the meeting Link by click on this button" className="btn btn-primary" type="submit" disabled={generateloading}>{generateloading ? "Plese Wait...": "Continue"}</button>
          </form>
          <br />
        </>
      }

      {meetLink && (
        <>
          {/* <p>Meet Link: <a href={meetLink}>{meetLink}</a></p> */}
          <div class="col-md-12 mb-3 d-none">
              <div className="form_group">
                <label class="form-label" for="validationCustomUsername">Meeting</label>
                <input className="form-control icon_v1" type="text" placeholder="Google Meet" value={meetLink} ref={meetLinkInputRef} readOnly />
                <i className="h2 fa fa-clone opacity-80" onClick={copyToClipboard}></i>
              </div>
            </div>
            {/* handleSendInvite */}
          <button className="btn btn-primary" onClick={()=>sendEmail()} type="submit"disabled={generateloading1}>{generateloading1 ? "Plese Wait...": "Send"}</button>

        </>
      )}
    </div>
  );
}

export default CreateMeet;
